import { render, staticRenderFns } from "./SmyCheckBox.vue?vue&type=template&id=515e2adc&scoped=true&"
import script from "./SmyCheckBox.vue?vue&type=script&lang=js&"
export * from "./SmyCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./SmyCheckBox.vue?vue&type=style&index=0&id=515e2adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e2adc",
  null
  
)

export default component.exports